  <div class="quick-filter-box">
  
    <div class="applied-filter-holder">
  
      @for (tag of taggedFilters; track tag.key) {
  
        <!-- LABEL -->
        <div class="m-r-4 no-text-wrap">
          {{ tag.key }}
        </div>
  
        @if (tag.key === 'Status') {
          <!-- Status: individual dismissable tags -->
          @if (isArray(tag.value)) {
            @for (item of asStringArray(tag.value); track item) {
              <mc-tag
                class="m-r-4 extra-height"
                appearance="neutral-inverse"
                fit="small"
                withaction
                (click)="unselectSpecificFilter(tag, item)"
                (keydown)="handleKeyDown($event)">
                {{ item }}
              </mc-tag>
            }
          } @else {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(tag)"
              (keydown)="handleKeyDown($event)">
              {{ tag.value }}
            </mc-tag>
          }
        } @else {
          <!-- All other filters: tag-with-overflow, overflowCount=2 -->
          <app-tag-with-overflow
            class="m-r-4"
            [data]="toStringArray(tag.value)"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="getUnselectFn(tag)">
          </app-tag-with-overflow>
        }
      }
  
      <!-- CLEAR ALL -->
      @if (taggedFilters.length > 0) {
        <mc-button
          class="clear-btn"
          variant="plain"
          appearance="primary"
          fit="small"
          (click)="clearAllSelectedFilters()"
          (keydown)="handleKeyDown($event)">
          Clear All
        </mc-button>
      }
  
    </div>
  
    <!-- RIGHT SIDE BUTTON -->
    <div class="utility-buttons">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">

        <mc-button
          slot="trigger"
          class="utility-button-no-round"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          fit="medium"
          (click)="showAdvanceFiltersModal()"
          (keydown)="handleKeyDown($event)">
        </mc-button>

        <span>Filters</span>
      </mc-tooltip>
    
    
        <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
          <mc-button
            slot="trigger"
            class="utility-button-no-round"
            icon="tray-arrow-down"
            variant="filled"
            appearance="neutral"
            hiddenlabel
            fit="medium"
            [loading]="isDownload"
            (click)="onDownload()"
            (keydown)="handleKeyDown($event)">
          </mc-button>

          <span>Download</span>
        </mc-tooltip>
      
    </div>
  
  </div>
  
  <mc-modal
    [open]="showAdvanceFilters"
    (closed)="closeAdvanceFiltersModal()"
    heading="User Filters"
    fit="small"
    dimension="large">
  
    <app-user-advanced-filters
      [bindMultiSelects]="showAdvanceFilters"
      [userFilterForm]="filterFormGroup.controls.userFilterForm"
      [activeTab]="activeTab">
    </app-user-advanced-filters>
  
  </mc-modal>